import { useState } from "react";

import type { MapColors } from "../../map/MapColors";

const read = (style: CSSStyleDeclaration, name: string): string =>
  style.getPropertyValue(`--color-${name}`).trim() || "#000000";

// Цвета карты из токенов темы: canvas не понимает CSS-переменные, читаем их один раз.
export const useMapColors = (): MapColors => {
  const [colors] = useState<MapColors>(() => {
    const style = getComputedStyle(document.documentElement);
    return {
      teams: [read(style, "team-amber"), read(style, "team-sapphire")],
      me: read(style, "map-me"),
      mate: read(style, "map-mate"),
      enemy: read(style, "map-enemy"),
      missed: read(style, "map-missed"),
      kill: read(style, "map-kill"),
      boss: read(style, "map-boss"),
      backdrop: read(style, "map-backdrop"),
      ground: read(style, "map-ground"),
      street: read(style, "map-street"),
      building: read(style, "map-building"),
      ink: read(style, "map-ink"),
      muted: read(style, "muted"),
      accent: read(style, "accent"),
    };
  });
  return colors;
};
